import { apiV1BaseUrl as baseURL } from 'appConstants';

export const termsItems = [
  {
    id: 2,
    title: 'footer.terms',
    link: (language: string) => `${baseURL}/terms/${language}`,
  },
];
